import { render } from "./Mission.vue?vue&type=template&id=52f0823e&scoped=true"
import script from "./Mission.vue?vue&type=script&lang=js"
export * from "./Mission.vue?vue&type=script&lang=js"

import "./Mission.vue?vue&type=style&index=0&id=52f0823e&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f0823e"]])

export default __exports__